import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import * as z from 'zod';
import {
  CONVERSATION_PREFIX,
  ID_GLUE,
  type ConversationId,
} from '../../domain/conversation-id.value-object';

export class ConversationIdValidator implements Validator<ConversationId> {
  readonly standardSchema = z.templateLiteral([CONVERSATION_PREFIX, ID_GLUE, z.string().min(1)]);

  validate(value: unknown): Result<ConversationId, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);
    if (!parsed.success) {
      return err(
        new ValidationError(parsed.error.issues[0]?.message ?? 'Invalid conversation id.'),
      );
    }
    return ok(parsed.data);
  }
}
